export enum StorageKeysEnum {
  CALLING_CODES = 'CALLING_CODES',
  COOKIES_CONFIG = 'COOKIES_CONFIG',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SEARCH_HISTORY = 'SEARCH_HISTORY',
  SEARCH_PARAMS = 'SEARCH_PARAMS',
  USER = 'usuario',
  CONFIGCAT_USER_ID = 'configcat_user_id',
  USER_IP = 'user_ip',
}
